module.exports = __webpack_public_path__ + "static/img/jjfa5.f6064c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jjfa5.jpg
// module id = 9Jfo
// module chunks = 1